import room1Img from "../assets/img/room1-point3d-commercial-imaging-ltd-5BV56SdvLmo-unsplash.jpg";
import room2Img from "../assets/img/room2-point3d-commercial-imaging-ltd-oxeCZrodz78-unsplash.jpg";
import room3Img from "../assets/img/room3-reisetopia-aI6Su7Mu9Ro-unsplash.jpg";
import room4Img from "../assets/img/room4-vojtech-bruzek-Yrxr3bsPdS0-unsplash.jpg";

export type RoomSeedAmenityIcon = "Maximize" | "Snowflake" | "Coffee" | "Wifi" | "Shield";

export type RoomSeed = {
    type: string;
    beds: string;
    cancellation: "Free cancellation" | "Non-refundable";
    bestMatch?: boolean;
    photo?: string;
    amenities: Array<{ icon: RoomSeedAmenityIcon; label: string }>;
};

export const ROOM_SEED: RoomSeed[] = [
    {
        type: "Standard King",
        beds: "1 king bed",
        cancellation: "Free cancellation",
        bestMatch: true,
        photo: room1Img,
        amenities: [
            { icon: "Maximize", label: "25 m2" },
            { icon: "Snowflake", label: "Air con" },
            { icon: "Coffee", label: "Breakfast" },
            { icon: "Wifi", label: "Free WiFi" },
        ],
    },
    {
        type: "Deluxe Suite",
        beds: "1 king bed + sofa",
        cancellation: "Non-refundable",
        photo: room2Img,
        amenities: [
            { icon: "Maximize", label: "32 m2" },
            { icon: "Snowflake", label: "Air con" },
            { icon: "Coffee", label: "Breakfast" },
            { icon: "Wifi", label: "Free WiFi" },
        ],
    },
    {
        type: "Ocean View Queen",
        beds: "1 queen bed",
        cancellation: "Free cancellation",
        photo: room3Img,
        amenities: [
            { icon: "Maximize", label: "24 m2" },
            { icon: "Wifi", label: "Free WiFi" },
            { icon: "Coffee", label: "Breakfast" },
            { icon: "Shield", label: "Safe" },
        ],
    },
    {
        type: "Penthouse Suite",
        beds: "2 queen beds",
        cancellation: "Non-refundable",
        photo: room4Img,
        amenities: [
            { icon: "Maximize", label: "45 m2" },
            { icon: "Snowflake", label: "Air con" },
            { icon: "Wifi", label: "Free WiFi" },
            { icon: "Shield", label: "Safe" },
        ],
    },
];

export const DEFAULT_ROOM_SEED: RoomSeed = {
    type: "Room",
    beds: "1 bed",
    cancellation: "Non-refundable",
    amenities: [
        { icon: "Maximize", label: "20 m2" },
        { icon: "Wifi", label: "Free WiFi" },
    ],
};

export const getRoomSeedByType = (type: string): RoomSeed | undefined => {
    const normalized = String(type || "").trim().toLowerCase();
    return ROOM_SEED.find((room) => room.type.toLowerCase() === normalized);
};
